export default "__VITE_ASSET__BPgwMUSe__"